/* Import TinyMCE */
import tinymce from "tinymce";

/* Translation */
import "tinymce-i18n/langs/es";

/* Default icons are required for TinyMCE 5.3 or above */
import "tinymce/icons/default";

/* A theme is also required */
import "tinymce/themes/silver";
import "tinymce/models/dom";

/* Import the skin */
import "tinymce/skins/ui/oxide/skin";

/* Import plugins */
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/lists";
import "tinymce/plugins/charmap";
// import "tinymce/plugins/print";
import "tinymce/plugins/preview";
// import "tinymce/plugins/hr";
import "tinymce/plugins/anchor";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/media";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/table";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/template";
import { CSRF, bodyRequest, getData, requestOptions } from "../helpers";
// import "tinymce/plugins/paste";
// import "tinymce/plugins/help";

/* Import premium plugins */
/* NOTE: Download separately and add these to /src/plugins */
/* import './plugins/checklist/plugin'; */
/* import './plugins/powerpaste/plugin'; */
/* import './plugins/powerpaste/js/wordimport'; */

/* Import content css */
// import contentUiCss from "tinymce/skins/ui/oxide/content.css";
// import contentCss from "tinymce/skins/content/default/content.css";

export class BlogEditor extends HTMLTextAreaElement {
    connectedCallback() {
        tinymce.init({
            visual: false,
            target: this,
            height: 595,
            plugins:
                "advlist autolink link image lists charmap preview anchor pagebreak searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking table emoticons template",
            language: "es",
            promotion: false, // Quitar el botón de upgrade
            branding: false, // Quitar la marca de tiny
            // plugins: [
            // "advlist autolink link image lists charmap print preview hr anchor pagebreak",
            // "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
            // "table emoticons template paste help",
            // ],
            toolbar:
                "undo redo copy cut | fontfamily fontsize | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | " +
                "bullist numlist outdent indent | link anchor image | media | emoticons",
            // menu: {
            //     favs: {
            //         title: "My Favorites",
            //         items: "code visualaid | searchreplace | emoticons",
            //     },
            // },
            // menubar: "favs file edit view insert format tools table help",
            // content_style:
            // "body { font-family:Helvetica,Arial,sans-serif; font-size:14px; color: #7c8ea7; }",
            relative_urls: false, // Evita que TinyMCE convierta las URLs a relativas
            // remove_script_host: false, // Mantiene el host en las URLs, asegurando que son absolutas
            images_upload_handler: (blobInfo, progress) =>
                new Promise((resolve, reject) => {
                    bodyRequest.append(
                        "image",
                        blobInfo.blob(),
                        blobInfo.filename()
                    );

                    fetch(getData(this, "data-url"), requestOptions)
                        .then((r) => r.json())
                        .then((data) => resolve(data.location))
                        .catch((data) => reject(data.error));
                }),
        });
    }

    /**
     * Asigna al evento click la funcionalidad para mostrar y ocultar la contraseña
     * así como el cambio de icono de FontAwesome
     *
     * @return {Void}
     */
    addClickEvent() {
        //
    }
}

window.customElements.define("blog-editor", BlogEditor, {
    extends: "textarea",
});
